<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <div class="reduced-fit">
                <div class="main-content-header">
                    <h1>Tipo de Documentos</h1>
                </div>
                <LoadingContent v-if="isLoading" />
                <div class="row w-65">
                    <div class="col-lg-12 ">
                        <div class="card mb-30" >
                            <div class="card-content" >
                                <div class="card-body">
                                    <div class="card-header" >
                                        <h5 class="card-title">{{ titulo }}</h5>
                                    </div>
                                    <div class="row">
                                        <div class="col-10">
                                            <form>
                                                <div class="row ">
                                                    <label class="col-2 text-nowrap">ID</label>
                                                    <div class="col-3">
                                                        <input ref="numid" type="number" class="form-control form-control-sm" required disabled v-model="doc.numid" />													
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <label class="col-2 text-nowrap">Abrev.</label>
                                                    <div class="col-5"> 
                                                        <input ref="abrev" type="text" maxlength="10" class="form-control form-control-sm" required v-model="doc.abrev" />													
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <label class="col-2 text-nowrap">Documento</label>
                                                    <div class="col-10">
                                                        <input ref="tipo" maxlength="25" type="text" class="form-control form-control-sm" v-model="doc.tipo" />													
                                                    </div>
                                                </div>	
                                                <span class="linethrough"><h5>Campos para describir el documento</h5></span>
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 offset-md-6">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <span>Ligar a Campo</span>													
                                                            </div>
                                                            <div class="col-3 ">
                                                                <span>Cambiar</span>
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <label class="col-3 text-nowrap">Descr. 1:</label>
                                                            <div class="col-9">
                                                                <input type="text" maxlength="25" class="form-control form-control-sm" v-model="doc.descr1" />													
                                                            </div>
                                                        </div>	
                                                    </div>
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <input type="text" maxlength="50" class="form-control form-control-sm" v-model="doc.liga1" />													
                                                            </div>
                                                            <div class="col-3 form-check">
                                                                <input class="form-check-input" v-model="cambiar1" type="checkbox" >
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <label class="col-3 text-nowrap">Descr. 2:</label>
                                                            <div class="col-9">
                                                                <input type="text" maxlength="25" class="form-control form-control-sm" v-model="doc.descr2" />													
                                                            </div>
                                                        </div>	
                                                    </div>
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <input type="text" maxlength="50" class="form-control form-control-sm" v-model="doc.liga2" />													
                                                            </div>
                                                            <div class="col-3 form-check">
                                                                <input class="form-check-input" v-model="cambiar2" type="checkbox" >
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <label class="col-3 text-nowrap">Descr. 3:</label>
                                                            <div class="col-9">
                                                                <input type="text" maxlength="25" class="form-control form-control-sm" v-model="doc.descr3" />													
                                                            </div>
                                                        </div>	
                                                    </div>
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <input type="text" maxlength="50" class="form-control form-control-sm" v-model="doc.liga3" />													
                                                            </div>
                                                            <div class="col-3 form-check">
                                                                <input class="form-check-input" v-model="cambiar3" type="checkbox" >
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <label class="col-3 text-nowrap">Descr. 4:</label>
                                                            <div class="col-9">
                                                                <input type="text" maxlength="25" class="form-control form-control-sm" v-model="doc.descr4" />													
                                                            </div>
                                                        </div>	
                                                    </div>
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <input type="text" maxlength="50" class="form-control form-control-sm" v-model="doc.liga4" />													
                                                            </div>
                                                            <div class="col-3 form-check">
                                                                <input class="form-check-input" v-model="cambiar4" type="checkbox" >
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <label class="col-3 text-nowrap">Descr. 5:</label>
                                                            <div class="col-9">
                                                                <input type="text" maxlength="25" class="form-control form-control-sm" v-model="doc.descr5" />													
                                                            </div>
                                                        </div>	
                                                    </div>
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <input type="text" maxlength="50" class="form-control form-control-sm" v-model="doc.liga5" />													
                                                            </div>
                                                            <div class="col-3 form-check">
                                                                <input class="form-check-input" v-model="cambiar5" type="checkbox" >
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <label class="col-3 text-nowrap">Descr. 6:</label>
                                                            <div class="col-9">
                                                                <input type="text" maxlength="25" class="form-control form-control-sm" v-model="doc.descr6" />													
                                                            </div>
                                                        </div>	
                                                    </div>
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <input type="text" maxlength="50" class="form-control form-control-sm" v-model="doc.liga6" />													
                                                            </div>
                                                            <div class="col-3 form-check">
                                                                <input class="form-check-input" v-model="cambiar6" type="checkbox" >
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <label class="col-3 text-nowrap">Descr. 7:</label>
                                                            <div class="col-9">
                                                                <input type="text" maxlength="25" class="form-control form-control-sm" v-model="doc.descr7" />													
                                                            </div>
                                                        </div>	
                                                    </div>
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <input type="text" maxlength="50" class="form-control form-control-sm" v-model="doc.liga7" />													
                                                            </div>
                                                            <div class="col-3 form-check">
                                                                <input class="form-check-input" v-model="cambiar7" type="checkbox" >
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <label class="col-3 text-nowrap">Descr. 8:</label>
                                                            <div class="col-9">
                                                                <input type="text" maxlength="25" class="form-control form-control-sm" v-model="doc.descr8" />													
                                                            </div>
                                                        </div>	
                                                    </div>
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <input type="text" maxlength="50" class="form-control form-control-sm" v-model="doc.liga8" />													
                                                            </div>
                                                            <div class="col-3 form-check">
                                                                <input class="form-check-input" v-model="cambiar8" type="checkbox" >
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <label class="col-3 text-nowrap">Descr. 9:</label>
                                                            <div class="col-9">
                                                                <input type="text" maxlength="25" class="form-control form-control-sm" v-model="doc.descr9" />													
                                                            </div>
                                                        </div>	
                                                    </div>
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <input type="text" maxlength="50" class="form-control form-control-sm" v-model="doc.liga9" />													
                                                            </div>
                                                            <div class="col-3 form-check">
                                                                <input class="form-check-input" v-model="cambiar9" type="checkbox" >
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <label class="col-3 text-nowrap">Descr. 10:</label>
                                                            <div class="col-9">
                                                                <input type="text" maxlength="25" class="form-control form-control-sm" v-model="doc.descr10" />													
                                                            </div>
                                                        </div>	
                                                    </div>
                                                    <div class="col-md-6 col-12 ">
                                                        <div class="row ">
                                                            <div class="col-9">
                                                                <input type="text" maxlength="50" class="form-control form-control-sm" v-model="doc.liga10" />													
                                                            </div>
                                                            <div class="col-3 form-check">
                                                                <input class="form-check-input" v-model="cambiar10" type="checkbox" >
                                                            </div>
                                                        </div>	
                                                    </div>
                                                </div>	
                                            </form>
                                        </div>
                                        <div class="col-2">
                                            <ul class="d-block p-1 list-unstyled controls-form">
                                                <li><button @click="setDocumento()" class="btn btn-sm btn-success btn-block">Aceptar</button></li>
                                                <li><router-link to="/tipodocumentos" class="btn btn-sm btn-danger btn-block">Salir</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import handleForm from '@/mixins/handleForm';
import LoadingContent from '@/components/LoadingSpinner.vue'
import handleGlobals from '@/mixins/handleGlobals'

import SideBar from '@/components/SideBarNav.vue';
import TopBar from '@/components/TopBarNav.vue';
export default {
    components:{SideBar, TopBar,LoadingContent },
    mixins:[handleForm,handleGlobals],
    data(){
        return{
            id: this.$route.params.doc,
            modo: (this.$route.params.doc > 0 ? 'Modificando' : 'Creacion'), 
            doc: [],
            titulo: 'Agregando un Tipo de Documento',
        }
    },
    mounted(){
        this.llenaForma();
    },
    methods:{
        async llenaForma(){
            await this.getDocumento();
            this.titulo = this.$route.params.doc > 0 ? 'Cambiando un Tipo de Documento' :  'Agregando un Tipo de Documento'
        },
        getDocumento(){
            let req = []
            this.isLoading = true
             fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({ accion: "inicializar", modo:this.modo, archivo: "TipoDocs", id: this.id })
            }).then((response)=>{
                if(response.ok){
                    return response.json()
                }   
            }).then((data)=>{
                this.doc = data['res']
                req = data['req']
            }).finally(()=>{
                this.setRequired(req)
                this.isLoading = false
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        setDocumento(){
            fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({  accion: 'validar', archivo: "TipoDocs", modo:this.modo, record: this.doc }) 
            }).then((response)=>{
                if(response.ok){
                    return response.json();
                }   
            }).then((data)=>{
                if(data['res'] == 'error'){
                    this.showNotification = true
                    this.notificationTitle =  'Error'
                    this.notificationText = data['msg']
                    this.notificationRef = 'tipo'
                }else{
                    this.$router.push('/tipodocumentos')
                }
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        afterClose(){
           
            this.$refs[this.notificationRef].focus()
        }
    }
}
</script>